import React from "react";
import { Box, Text, Card, CardHeader, CardBody, List, ListItem, ListIcon } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import OptimalTradeConfig from "./OptimalTradeConfig";

const OptimalTradeConfigDescription = () => {
  return (
    <Box  mx="auto" mt={5}  overflow='auto'>
      <Card borderRadius="2xl" boxShadow="lg">
        <CardHeader>
          <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold">
            Optimal Trade Config API
          </Text>
        </CardHeader>
        <CardBody>
          <Text fontSize={{ base: "sm", md: "md" }} mb={4}>
            The <strong>Optimal Trade Config API</strong> provides real-time trading parameters to help users optimize their leverage, 
            collateral utilization, and position ratios for efficient risk management. This API dynamically adjusts values 
            based on Blindfolds' custom composite of market technical indicators and is updated every minute, providing the 
            optimal trade settings every time.
          </Text>
          
          <OptimalTradeConfig />
        </CardBody>
      </Card>
    </Box>
  );
};

export default OptimalTradeConfigDescription;
